import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography, CircularProgress, Alert } from '@mui/material';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import StoreMallDirectoryIcon from '@mui/icons-material/StoreMallDirectory';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import InvoiceStatsCard from '../../../components/Cards/InvoiceStatsCard';
import SettingsSummaryCard from '../../../components/SettingsSummaryCard';
import { getDashboardAnalytics, getApiError } from '../../../utils/api';

const Dashboard = () => {
  const [analytics, setAnalytics] = useState(null);
  console.log(analytics);
  const [businessSettings, setBusinessSettings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    setError('');
    
    // Fetch both analytics and business settings
    getDashboardAnalytics()
      .then((analyticsRes) => {
        if (!mounted) return;
        // Handle direct response data since it's not wrapped in data property
        setAnalytics(analyticsRes.data || {});
      })
      .catch(err => {
        if (!mounted) return;
        setError(getApiError(err));
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => { mounted = false; };
  }, []);

  if (loading) {
    return <Box p={3} textAlign="center"><CircularProgress /></Box>;
  }
  if (error) {
    return <Box p={3}><Alert severity="error">{error}</Alert></Box>;
  }
  if (!analytics) {
    return <Box p={3}><Alert severity="error">No analytics data available.</Alert></Box>;
  }

  return (
    <Box sx={{ p: { xs: 1, md: 3 }, bgcolor: 'background.default', minHeight: '100vh' }}>
      <Typography variant="h4" gutterBottom fontWeight={700} color="text.primary">
        Dashboard Overview
      </Typography>
      <Grid container spacing={2} mb={2}>
        <Grid item xs={12} sm={6} md={2.4}><InvoiceStatsCard label="Total Invoices" stats={analytics?.totalInvoices || {allTime: 0, last7Days: 0, today: 0}} icon={ReceiptLongIcon} /></Grid>
        <Grid item xs={12} sm={6} md={2.4}><InvoiceStatsCard label="Total Revenue" stats={analytics?.totalRevenue || {allTime: 0, last7Days: 0, today: 0}} icon={AttachMoneyIcon} /></Grid>
        <Grid item xs={12} sm={6} md={2.4}><InvoiceStatsCard label="Unique Customers" stats={analytics?.uniqueCustomers || {allTime: 0, last7Days: 0, today: 0}} icon={PeopleAltIcon} /></Grid>
        <Grid item xs={12} sm={6} md={2.4}><InvoiceStatsCard label="Active Shops" stats={analytics?.activeShops || {allTime: 0, last7Days: 0, today: 0}} icon={StoreMallDirectoryIcon} /></Grid>
        <Grid item xs={12} sm={6} md={2.4}><InvoiceStatsCard label="Whatsapp Delivered" stats={analytics?.whatsappDelivered || {allTime: 0, last7Days: 0, today: 0}} icon={CheckCircleIcon} /></Grid>
        <Grid item xs={12} sm={6} md={2.4}><InvoiceStatsCard label="Whatsapp Not Delivered" stats={analytics?.whatsappNotDelivered || {allTime: 0, last7Days: 0, today: 0}} icon={CancelIcon} /></Grid>
        <Grid item xs={12} sm={6} md={2.4}><InvoiceStatsCard label="Avg Invoice Value" stats={analytics?.avgInvoiceValue || {allTime: 0, last7Days: 0, today: 0}} icon={AttachMoneyIcon} /></Grid>
        <Grid item xs={12} sm={6} md={2.4}><InvoiceStatsCard label="Invoices per Customer" stats={analytics?.invoicesPerCustomer || {allTime: 0, last7Days: 0, today: 0}} icon={PeopleAltIcon} /></Grid>
        <Grid item xs={12} sm={6} md={2.4}><InvoiceStatsCard label="Invoices per Shop" stats={analytics?.invoicesPerShop || {allTime: 0, last7Days: 0, today: 0}} icon={StoreMallDirectoryIcon} /></Grid>
      </Grid>
      
      {/* Settings Summary Section */}
      <Typography variant="h5" gutterBottom fontWeight={600} color="text.primary" sx={{ mt: 4, mb: 2 }}>
        Business Settings Overview
      </Typography>
      <Grid container spacing={3}>
        {businessSettings.slice(0, 4).map((business) => (
          <Grid item xs={12} sm={6} md={3} key={business.business_id}>
            <SettingsSummaryCard
              title={business.business_name}
              settings={{
                whatsappSendAs: business.whatsapp_send_as || 'pdf',
                businessName: business.business_name
              }}
              type="admin"
              loading={loading}
            />
          </Grid>
        ))}
        {businessSettings.length === 0 && (
          <Grid item xs={12}>
            <Typography variant="body1" color="text.secondary" align="center">
              No business settings found
            </Typography>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default Dashboard; 
